import { Button, ConfigProvider, Divider, Rate } from "antd";
import React, { useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import EnquiryModal from "../Modal/EnquiryModal";

export default function VendorRight({ VenuesDetails }) {
  const [isOpen, setIsOpen] = useState(false);
  const [enquiryModalVisible, setEnquiryModalVisible] = useState(false);

  return (
    <div
      className="venues-details-page-section-right-side-main-con sticky-right-section"
      style={{ alignItems: "flex-start" }}
    >
      <h3>{VenuesDetails?.name}</h3>
      <p>
        {VenuesDetails?.based_area}, {VenuesDetails?.city}
      </p>
      <div className="d-flex align-items-center" style={{ marginBottom: 35 }}>
        <ConfigProvider
          theme={{
            components: {
              Rate: {
                starColor: "#B59410",
              },
            },
          }}
        >
          <Rate disabled defaultValue={2} />
        </ConfigProvider>
        &nbsp;&nbsp;
        <strong>4.8 Excellent</strong>&nbsp;&nbsp;
        <p style={{ margin: 0, textDecoration: "underline" }}>10 Reviews</p>
      </div>

      <div
        className="venues-details-page-section-right-side-price-main-con"
        onClick={() => setIsOpen(!isOpen)}
        style={{ cursor: "pointer" }}
      >
        <div className="venues-details-page-section-right-side-head">
          <h3 style={{ fontSize: 18 }}>Starting Price</h3>
          <div className="venues-details-page-section-right-side-head-dropdown">
            <h4>
              Pricing Info <IoIosArrowDown />
            </h4>
          </div>
        </div>

        <Divider />

        <div className="venues-details-page-section-right-side-food">
          {VenuesDetails?.pricing?.map((elem) => {
            const { price, price_category, price_name, price_type } = elem;
            return (
              <>
                <div className="venues-details-page-section-right-side-food-con">
                  <h6>
                    ₹ {price} <span>({price_name})</span>
                  </h6>
                  <p>{price_category}</p>
                </div>
              </>
            );
          })}
        </div>
      </div>

      <div className="pricingButton">
        <Button
          style={{
            backgroundColor: "var(--primaryColor)",
            color: "white",
            borderRadius: 0,
            width: "100%",
            height: 45,
            marginTop: 35,
          }}
          icon={<IoCall />}
          onClick={() => setEnquiryModalVisible(true)}
        >
          Request Quote
        </Button>
      </div>

      <EnquiryModal
        visible={enquiryModalVisible}
        onCancel={() => setEnquiryModalVisible(false)}
        vendorDetails={VenuesDetails}
      />
    </div>
  );
}
